import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Layout, Select, Button, Row, Col, Input, Form, Checkbox, Icon } from 'antd'

import ServicefieldsPopup from '@components/Popup/ServicefieldsPopup'
import TermsListPopup from '@components/Popup/TermsListPopup'
import CollectionTypesPopup from '@components/Popup/CollectionTypesPopup'

@inject((store: any) => {
    const {
        collectionsStore,
        categoriesStore,
        popupStore,
        servicefieldsStore,
        collectionTypesStore,
        termsStore
    } = store
    return { collectionsStore, categoriesStore, popupStore, servicefieldsStore, collectionTypesStore, termsStore }
})
@observer
class SearchBar extends Component<any, any> {
    componentDidMount() {
        this.getTypes()
    }

    handleFilterChange = (name, value) => {
        const { setFilter } = this.props.collectionsStore
        setFilter(name, value)
    }

    getTypes = async () => {
        const { servicefieldsStore, collectionTypesStore } = this.props
        await servicefieldsStore.getServicefields()
        await collectionTypesStore.getCollectionTypes()
    }

    render() {
        const { categoriesStore, servicefieldsStore, collectionTypesStore } = this.props
        const { filters, getCollections, resetFilters, paging } = this.props.collectionsStore
        const {
            type,
            service_field,
            category,
            description,
            freeSearch,
            term_id
        } = this.props.collectionsStore.paging.filters
        const typeTitle = type === 'EMPTY' ? ', ללא סוג' : `${type ? `, מסוג ${type}` : ''}`
        const serviceFieldTitle =
            service_field === 'EMPTY'
                ? ', ללא תחום שירות'
                : `${
                      service_field
                          ? `, בתחום ${servicefieldsStore.list.filter(field => field.id === service_field)[0].name}`
                          : ''
                  }`
        const categoriesTitle =
            category === 'EMPTY'
                ? ', ללא קטגוריה'
                : `${
                      category && categoriesStore.indexedCategories[category]
                          ? `, בקטגורית ${categoriesStore.indexedCategories[category].name}`
                          : ''
                  }`
        const termTitle = term_id ? `, תחת תנאי מספר ${term_id}` : ''
        const freeSearchTitle = freeSearch ? `, הכוללים את המושג "${freeSearch}"` : ''
        const descriptionTitle = description ? ', ללא תיאור' : ''
        const resultsTitle = `נמצאו ${paging.total} זכויות${serviceFieldTitle}${typeTitle}${categoriesTitle}${freeSearchTitle}${descriptionTitle}${termTitle}`
        return (
            <Form
                onSubmit={e => {
                    e.preventDefault()
                    getCollections(1)
                }}
            >
                <Layout style={{ padding: '0 1rem' }}>
                    <Row gutter={10}>
                        <Col xs={3}>
                            <strong>סינון לפי קטגוריות</strong>
                            <Select
                                style={{ width: '100%' }}
                                value={filters.category}
                                onChange={e => {
                                    this.handleFilterChange('category', e)
                                    getCollections(1)
                                }}
                                placeholder="כל הקטגוריות"
                            >
                                <Select.Option value={null}>כל הקטגוריות</Select.Option>
                                <Select.Option value={'EMPTY'}>-- ללא קטגוריה</Select.Option>
                                {categoriesStore.list.map((category, index) => (
                                    <Select.Option key={`${index}_category`} value={category.id}>
                                        {category.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Col>
                        <Col xs={3}>
                            <strong>סינון לפי סוג הזכויות</strong>
                            <Select
                                style={{ width: '100%' }}
                                value={filters.collection_type_id}
                                onChange={e => {
                                    this.handleFilterChange('collection_type_id', e)
                                    getCollections(1)
                                }}
                                placeholder="כל סוגי הזכויות"
                            >
                                <Select.Option value={null}>כל סוגי הזכויות</Select.Option>
                                <Select.Option value="EMPTY">-- ללא סוג זכות</Select.Option>
                                {collectionTypesStore.list.map((type, index) => {
                                    if (type.name) {
                                        return (
                                            <Select.Option key={`${index}_types`} value={type.id}>
                                                {type.name}
                                            </Select.Option>
                                        )
                                    }
                                })}
                            </Select>
                            <a
                                onClick={() => this.props.popupStore.togglePopup('editCollectionTypes')}
                                style={{ textDecoration: 'underline' }}
                            >
                                <Icon type="edit" /> ערוך סוגי זכויות
                            </a>
                        </Col>
                        <Col xs={3}>
                            <strong>סינון לפי תחום שירות</strong>
                            <Select
                                style={{ width: '100%' }}
                                value={filters.service_field}
                                onChange={e => {
                                    this.handleFilterChange('service_field', e)
                                    getCollections(1)
                                }}
                                placeholder="כל התחומים"
                            >
                                <Select.Option value={null}> כל התחומים</Select.Option>
                                <Select.Option value="EMPTY">-- ללא תחום שירות</Select.Option>
                                {servicefieldsStore.list.map((service_field, index) => (
                                    <Select.Option key={index} value={service_field.id}>
                                        {service_field.name}
                                    </Select.Option>
                                ))}
                            </Select>
                            <a
                                onClick={() => this.props.popupStore.togglePopup('editServicefields')}
                                style={{ textDecoration: 'underline' }}
                            >
                                <Icon type="edit" /> ערוך תחומי שירות
                            </a>
                        </Col>
                        <Col xs={4}>
                            <strong>חיפוש חופשי בתיאור ושם</strong>
                            <Input.Search
                                placeholder="הזן מילות חיפוש"
                                value={filters.freeSearch}
                                onChange={e => this.handleFilterChange('freeSearch', e.target.value)}
                            />
                            <div>
                                <Checkbox
                                    checked={filters.description === 'EMPTY'}
                                    onChange={e => {
                                        this.handleFilterChange('description', e.target.checked ? 'EMPTY' : null)
                                        getCollections(1)
                                    }}
                                />
                                {<span>הצג תוצאות שחסר בהן תיאור</span>}
                            </div>
                        </Col>
                        <Col xs={4}>
                            <strong>חיפוש מזהה</strong>
                            <Input.Search
                                placeholder="הזן מזהה זכות"
                                value={filters.id}
                                onChange={e => this.handleFilterChange('id', e.target.value)}
                            />
                        </Col>
                        <Col xs={4}>
                            <strong>חיפוש על פי שם עורך</strong>
                            <Input.Search
                                placeholder="הזן שם מלא או חלקי"
                                value={filters.updated_by}
                                onChange={e => this.handleFilterChange('updated_by', e.target.value)}
                            />
                        </Col>
                        <Col xs={3}>
                            <strong>סינון על פי תנאים</strong>
                            <Button
                                style={{ margin: '0', width: '100%' }}
                                onClick={async () => {
                                    this.props.termsStore.getFilteredList()
                                    this.props.popupStore.togglePopup('termsList', { action: 'filter' })
                                }}
                            >
                                לחץ לבחירת תנאי
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={21}>
                            <Button
                                style={{ margin: '0' }}
                                onClick={() => {
                                    resetFilters()
                                    getCollections(1)
                                }}
                            >
                                איפוס חיפוש
                            </Button>
                            <Button type="primary" style={{ margin: '0.8rem 0.5rem 0' }} htmlType="submit">
                                חפש זכויות
                            </Button>
                            <span style={{ fontSize: '1rem' }}>{resultsTitle}</span>
                        </Col>
                        <Col xs={3}>
                            <Button
                                style={{ width: '100%' }}
                                onClick={() => this.props.popupStore.togglePopup('addCollection')}
                            >
                                הוספת זכות חדשה +
                            </Button>
                        </Col>
                    </Row>
                </Layout>
                <TermsListPopup />
                <ServicefieldsPopup />
                <CollectionTypesPopup />
            </Form>
        )
    }
}

export default withRouter(SearchBar)
